import requestUtils from 'api/requestUtils'
import { BusinessResponses } from '@luxuryescapes/contract-business'

async function requestCheckEmailAssociation(email: string) {
  try {
    const response = await requestUtils.get<BusinessResponses.BaseResponse<boolean>>(`/api/business-traveller/businesses/email-exists?email=${encodeURIComponent(email)}`)

    if (!response.result) {
      return Promise.reject({ message: 'This email is not registered.' })
    }
    return true
  } catch {
    return Promise.reject({ message: 'This email is not registered.' })
  }
}

export default requestCheckEmailAssociation
